import { estimateStringWidth } from '@shopify/polaris-viz-core';
import characterWidths from '../data/character-widths.json.js';
import characterWidthOffsets from '../data/character-width-offsets.json.js';

function estimateStringWidthWithOffset(string, fontSize, fontWeight) {
  var _characterWidthOffset, _characterWidthOffset2;

  const width = estimateStringWidth(string, characterWidths);
  const fontSizeOffset = (_characterWidthOffset = characterWidthOffsets.fontSize[fontSize]) !== null && _characterWidthOffset !== void 0 ? _characterWidthOffset : 1;
  const fontWeightOffset = (_characterWidthOffset2 = characterWidthOffsets.fontWeight[fontWeight]) !== null && _characterWidthOffset2 !== void 0 ? _characterWidthOffset2 : 1;
  const adjustedWidth = width * fontSizeOffset * fontWeightOffset;
  return Math.round((adjustedWidth + Number.EPSILON) * 100) / 100;
}

export { estimateStringWidthWithOffset };
